module.exports = __webpack_public_path__ + "static/11-1bf2b247f88bc9222e8b3f60c565d966.png";